import { FIREBASE_ERROR_CODES } from './errors-firebase';
import { USER_SYSTEM_ERROR_CODES } from './errors-user-system';
// --- local imports ------

function handleGenericError(error) {
	if (error && error.message) {
		console.error(error);
		return error.message;
	}

	return null;
}

export const ERROR_CODES = {
	FIREBASE: FIREBASE_ERROR_CODES,
	USER_SYSTEM: USER_SYSTEM_ERROR_CODES
};

export function handleBaseError(error) {
	const genericError = handleGenericError(error);
	if (genericError !== null) {
		return genericError;
	}

	return 'Unknown Error!';
}

export function createApiError(jsonResponse, fallbackMessage) {
	const message = jsonResponse?.message || jsonResponse?.error?.message || fallbackMessage;
	const error = new Error(message);
	// The user system names its code `errorCode` (the current Nest service) or
	// `codeName` (the Express service it replaced). Neither is `code`, so reading
	// only that left `error.code` holding the HTTP status on every failure and
	// made every USER_SYSTEM case in the login screen unreachable.
	error.code = jsonResponse?.errorCode
		|| jsonResponse?.codeName
		|| jsonResponse?.code
		|| jsonResponse?.error?.code;
	return error;
}

export async function parseApiResponse(response, fallbackMessage) {
	const contentType = response.headers.get('content-type');
	if (!contentType || !contentType.includes('application/json')) {
		if (!response.ok) {
			const error = new Error(`${fallbackMessage} (HTTP ${response.status})`);
			error.code = response.status;
			error.status = response.status;
			throw error;
		}
		throw new Error('Expected JSON response but got non-JSON format');
	}

	const jsonResponse = await response.json();

	if (!response.ok || jsonResponse.error) {
		const fallbackErrorCode = response.status;
		const error = createApiError(jsonResponse, fallbackMessage);
		// Kept alongside `code` so a failure can still be classified when the body
		// carries no code of its own — a role rejection is a bare 403, and the
		// registration service throws plain 400s.
		error.status = response.status;
		if (!error.code && fallbackErrorCode) error.code = fallbackErrorCode;
		throw error;
	}

	return jsonResponse;
}
